import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet, createBrowserRouter, RouterProvider } from 'react-router';
import { RequireSession, SelectionProvider } from './session';
import LoginPage from './pages/Login';
import SetupPage from './pages/Setup';
import ScanPage from './pages/Scan';
import './styles.css';
import { loadTerms } from './terms';

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, staleTime: 10_000, refetchOnWindowFocus: false } } });

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: (
      <RequireSession>
        <SelectionProvider>
          <Outlet />
        </SelectionProvider>
      </RequireSession>
    ),
    children: [
      { index: true, element: <SetupPage /> },
      { path: 'scan', element: <ScanPage /> },
    ],
  },
]);


const container = document.getElementById('root');
if (!container) throw new Error('No #root element');
// The deployment's words before the first screen (D-378), so no label flips
// from "Dates" to "Games" after it is drawn. Never waits more than a moment.
void loadTerms().finally(() => {
  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
});
